import { twMerge } from "tailwind-merge";

import { CancelSubmitButtons } from "~/common/components";
import Modal from "~/common/components/Modal";

interface SessionBillingNoteConfirmationModalProps {
  isPending: boolean;
  show: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

export const SessionBillingNoteConfirmationModal = ({
  isPending,
  show,
  onClose,
  onSubmit,
}: SessionBillingNoteConfirmationModalProps) => (
  <Modal
    show={show}
    title="Complete billing note"
    description="Are you sure you want to complete the billing note? Once completed, you won't be able to make further changes."
    onClose={onClose}
  >
    <CancelSubmitButtons
      cancelClassName="w-fit"
      submitClassName={twMerge("w-fit", isPending && "w-60 justify-center")}
      containerClassName="w-fit self-end"
      submitButtonLabel="Complete billing note"
      submitButtonType="button"
      handleCancel={onClose}
      isSubmitting={isPending}
      handleSubmit={onSubmit}
    />
  </Modal>
);
